import { historyConstant } from "../constants/historyConstant";
import type { HistoryEvent } from "../../types/history";

export interface HistoryState {
  historyByLead: Record<number, HistoryEvent[]>;
  loading: boolean;
  error: string | null;
}

interface HistoryAction {
  type: string;
  data?: {
    leadId: number;
    history: HistoryEvent[];
  };
  payload?: any;
  error?: string;
}

const initialState: HistoryState = {
  historyByLead: {},
  loading: false,
  error: null,
};

export default function history(state = initialState, action: HistoryAction): HistoryState {
  switch (action.type) {
    // Get Lead History
    case historyConstant.GET_LEAD_HISTORY_R:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case historyConstant.GET_LEAD_HISTORY_S: {
      const { leadId, history } = action.data || {};
      return {
        ...state,
        historyByLead: {
          ...state.historyByLead,
          [leadId]: history || [],
        },
        loading: false,
      };
    }

    case historyConstant.GET_LEAD_HISTORY_F:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Clear History State
    case historyConstant.CLEAR_HISTORY_STATE:
      return initialState;

    default:
      return state;
  }
}
